import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";

import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import { Select, MenuItem, Checkbox, ListItemText, Input, Button, Typography } from '@material-ui/core'

import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import IncomingLedgers from "./IncomingLedgers";
import OutgoingLedgers from "./OutgoingLedgers";
import SuperLedgerReportModal from "./SuperLedgerReportModal";
import Loading from "../../components/loadingSpinner/Loading";
import { ProfileType } from "../../types/enum";
import StaffFilter from "../../components/filters/StaffFilter";
import ReportDateFilterGigs from "../../components/reports/ReportDateFilterGigs";
import BookingCalendarFilter from "../../components/booking/bookingCalendarFilter";
import ReportDateFilter from "../../components/reports/ReportDateFilter";
import SelectFieldVenueFilter from "../../components/fields/SelectFieldVenueFilter";
import MvrIntroductionDialog from "../../components/superPay/MvrIntroductionDialog";

@inject("templateStore", "profileStore", "superLedgerStore", "reportStore", "commonStore", "agentActStore", "venueActStore","staffFilterStore")
@withRouter
@observer
class SuperLedgers extends Component {
    
    handleRemove = (value) => {
        return value.replace(/[, ]/g, '')
    };
    loadOutgoingLedgers = () => {
            this.loadOutgoing()

    };

    loadOutgoing = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.superLedgerStore.getLedgersByPayeeId(currentProfile.id, 1).then(() => {
            this.setState({
                ...this.state,
                isLoading: false,
                isLoaded: true,
                firstLoaded: true
            });
        });
    }


    loadIncomingLedgers = () => {
        this.loadIncoming()
        
    }
    loadIncoming = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile();

        this.props.superLedgerStore.getLedgersByPayerId(currentProfile.id, 1).then(() => {
            this.setState({
                tabValue: 1,
                isLoading: false,
                incomingLoaded: true
            });
        })
    }
    constructor(props) {
        super(props);
        this.props.reportStore.resetFilterData();
        this.props.superLedgerStore.resetLedgerPage()
        // this.props.superLedgerStore.clearIncomingOutgoingInvoices();
        // this.props.superLedgerStore.resetInvoicePage()
        this.state = {
            tabValue: 0,
            isLoading: false,
            isLoaded:false,
            firstLoaded:false,
            incomingLoaded: false,
            isFinished:false,
            actRosters: [],
            reportModalOpen: false,
            selectedReportLedgers: [],
            reportLedgerType: "outgoing"
        };
    }

    handleCloseReportModal = () => {
        this.setState({ reportModalOpen: false, selectedReportLedgers: [], reportLedgerType: "outgoing" });
    };

    handleOpenReportModalWithLedgers = (ledgers, ledgerType) => {
        this.setState({ 
            reportModalOpen: true, 
            selectedReportLedgers: ledgers,
            reportLedgerType: ledgerType
        });
    };

     componentDidMount = () => {
            
            const currentProfile = this.props.profileStore.getCurrentProfile();
            this.props.reportStore.initialFilter();
            let currentType = ""
            if (this.props.profileStore.currentProfile && this.props.profileStore.currentProfile.typeString){
                currentType = this.props.profileStore.currentProfile.typeString === "staff" ? "venue" : this.props.profileStore.currentProfile.typeString;
    
            }
           
              if (currentProfile){
                    this.setState({
                        ...this.state,
                        isLoading: false,
                        firstLoaded: false,
                    });
                     if(currentProfile?.type === ProfileType.Staff.ordinal){
                        Promise.all(
                            [
                                this.props.superLedgerStore.getLedgersByPayerId(currentProfile.id, 1),
                                this.props.venueActStore.getStaffActRosterInvoiceWithAdmin(currentProfile.id, true)
                            ]
                        ).then((response) => {
                            this.setState({
                                ...this.state,
                                isLoading: false,
                                isLoaded: true,
                                firstLoaded: true,
                                actRosters: response[1]
                            });
                        });
                     }
                     if(currentProfile.type === ProfileType.Agent.ordinal){
                        Promise.all(
                            [
                                this.loadOutgoingLedgers(),
                                this.props.agentActStore.getAgentActRosterForMyGigs(currentProfile?.id),
                                this.props.agentActStore.getAgentMyActsForMyGigs(currentProfile?.id)
                            ]
                        ).then((response) => {
                            this.setState({
                                ...this.state,
                                isLoading: false,
                                isLoaded: true,
                                firstLoaded: true,
                                actRosters: [...response[1], ...response[2]]
                            });
                        });
                     }else{
                        Promise.all(
                            [
                                this.loadOutgoingLedgers(),
                            ]
                        ).then(() => {
                            this.setState({
                                ...this.state,
                                isLoading: false,
                                isLoaded: true,
                                firstLoaded: true,
                            });
                        });
                     }
                   
                } else {
                    const currentUser = this.props.profileStore.getCurrentProfile();
                    this.currentUserId = currentUser?.id;
                    this.setState({
                        ...this.state,
                        isLoading: false,
                        isLoaded:false
                    });
                }
                
                if (this.props.match.params.superLedgerId) {
                    this.props.reportStore.setSuperLedgerId(this.props.match.params.superLedgerId)
                }

                if (this.props.match.params.tab && this.props.match.params.tab === "incoming") {
                    this.handleTabChange(null, 1)
                 }
    
        };

    

  
    handleTabChange = (event, value) => {
        const { tabValue } = this.state
        this.setState({
            tabValue: value,
            isLoading: false
        });
        
        if(tabValue !== value){
            this.props.superLedgerStore.resetFilter();
            this.props.superLedgerStore.setSelectedIncomingLedgers(undefined);
            if(value === 1 && !this.state.incomingLoaded){
                this.loadIncomingLedgers()
            }else{
                this.setState({
                    tabValue: value,
                    isLoading: false
                });
            }
            
        }
       
    };
    

    renderTabComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <OutgoingLedgers onOpenReport={this.handleOpenReportModalWithLedgers} />;
            case 1:
                return <IncomingLedgers onOpenReport={this.handleOpenReportModalWithLedgers} />;
            default:
                return "";
        }
    };


    renderTabStaffComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <IncomingLedgers onOpenReport={this.handleOpenReportModalWithLedgers} />;
            default:
                return "";
        }
    };
    renderTabTitle = (title, list) => {
        return list && list.length > 0 ? (
            <Badge color="primary" style={{ paddingRight: "16px" }} badgeContent={list ? list.length : 0}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    reloadLedger = filterData => {
        const { currentProfile } = this.props.profileStore;
        this.setState({
            ...this.state,
            isLoading: false
        });
        this.props.superLedgerStore.resetLedgerPage()
        if (filterData) {
            this.props.reportStore.setOrganisationFilter(filterData.organisation);
            this.props.reportStore.setStateFilter(filterData.state);
            this.props.reportStore.setRegionFilter(filterData.region);
            this.props.reportStore.setVenueFilter(filterData.venue);

            this.props.reportStore.setStartDate(filterData.startDate);
            this.props.reportStore.setEndDate(filterData.endDate);
        }

        const { isGrouped } = this.props.superLedgerStore;
        Promise.all([
            isGrouped
                ? this.props.superLedgerStore.getGroupedLedgersByPayerId(currentProfile.id)
                : this.props.superLedgerStore.getLedgersByPayerId(currentProfile.id, 1),
            isGrouped
                ? this.props.superLedgerStore.getGroupedLedgersByPayeeId(currentProfile.id)
                : this.props.superLedgerStore.getLedgersByPayeeId(currentProfile.id, 1)
        ]).then(() => {
            this.setState({
                ...this.state,
                isLoading: false
            });
        });
    };

    handleStatusFilterChange = e => {
        this.props.reportStore.setInvoiceStatusFilter(e.target.value);
        this.reloadLedger();
    }


    handleSelectAct = value => {
        this.props.reportStore.setActFilter(value);
        this.reloadLedger();
    }

    mapContactSuggestions = (profileType) => {
        const { incomingLedgers, outgoingLedgers } = this.props.superLedgerStore;
        const { tabValue } = this.state;
        var suggestions = this.mapActToSuggestions();
        if(profileType === ProfileType.Staff.ordinal){
            incomingLedgers.forEach(x => {
                if(x && x.payee && !suggestions.find(suggestion => suggestion.value === x.payeeId)){
                    suggestions.push({
                        value: x.payeeId,
                        label: x.payee.profileName ? x.payee.profileName : `${x.payee.firstName || ''} ${x.payee.lastName || ''}`.trim()
                    })
                }
            });
        }else{
            if(tabValue === 0){
                outgoingLedgers.forEach(x => {
                    if(x && x.payer && !suggestions.find(suggestion => suggestion.value === x.payerId)){
                        suggestions.push({
                            value: x.payerId,
                            label: x.payer.profileName ? x.payer.profileName : `${x.payer.firstName || ''} ${x.payer.lastName || ''}`.trim()
                        })
                    }
                });
            }
            else if(tabValue === 1 ){
                incomingLedgers.forEach(x => {
                    if(x && x.payee && !suggestions.find(suggestion => suggestion.value === x.payeeId)){
                        suggestions.push({
                            value: x.payeeId,
                            label: x.payee.profileName ? x.payee.profileName : `${x.payee.firstName || ''} ${x.payee.lastName || ''}`.trim()
                        })
                    }
                });
            }
        }
    
        return suggestions;
    }

    handleSelectContactFilter = value => {
        if(value){
            this.props.superLedgerStore.setFilterAttr('contactName', value);
        }else{
            this.props.superLedgerStore.setFilterAttr('contactName', undefined);
        }
        
        this.reloadLedger();
    }

    mapActToSuggestions = () => {
        const {actRosters} = this.state
        let acts = [];
      
        actRosters.forEach(actRoster => {
            if(!acts.find(x => x.id === actRoster.actId)){
                // console.log("gading", actRoster.act)
                acts.push(actRoster.act);
            }
        });

        acts.sort((a, b) => (a.actNameString < b.actNameString ? -1 : 1))
       
        var suggestions = [];
        acts.forEach(x => {
            if(!suggestions.find(suggestion => suggestion.value === x.actAdminId)){
                suggestions.push({
                    value: x.actAdminId,
                    label: x.actAdmin? x.actAdmin.profileName ? x.actAdmin.profileName : x.actAdmin.firstName + " " + x.actAdmin.lastName : x.myMusician? x.myMusician.profileName ?  x.myMusician.profileName : x.myMusician.firstName + " " + x.myMusician.lastName  : x.actName
                })
            }
        });
      
        return suggestions
    }


    render() {
        const { currentProfile } = this.props.profileStore;
        const { isLoading, isLoaded,firstLoaded } = this.state;
        const { invoiceStatusFilter } = this.props.reportStore; 
        const { filter } = this.props.superLedgerStore;

        const breadcrumb = [];
        if (currentProfile && currentProfile.type){
            [{ name: "Dashboard", link: "/" + this.props.templateStore.getTypeString(currentProfile.type) }, { name: "Invoices" }];
        }
        const { token } = this.props.commonStore;
        let hasSubscribe = false;
        let currentType = ""

        // if(currentProfile && !firstLoaded ){
        //     this.loadInitialData();
        // }
        if (this.props.profileStore.currentProfile && this.props.profileStore.currentProfile.typeString) {
            currentType = this.props.profileStore.currentProfile.typeString === "staff" ? "venue" : this.props.profileStore.currentProfile.typeString;
        }
        
        // if (token && currentProfile && jwtDecode(token).scope.filter(x => x === currentType).length > 0) hasSubscribe = true;

     
        const isStaffWithoutFinancial =
            currentProfile?.type === ProfileType.Staff.ordinal &&
            currentProfile?.hasOrganisation &&
            !currentProfile?.isOwnOrganization &&
            currentProfile?.allowInvoices === false;

        return (
            <div>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Fragment>
                        <Breadcrumb links={breadcrumb} />
                        {!isStaffWithoutFinancial && currentProfile && <MvrIntroductionDialog />}
                        {isStaffWithoutFinancial ? (
                            <div style={{ textAlign: "center", padding: "60px 24px", color: "#6b7280" }}>
                                <Typography variant="title" style={{ fontWeight: 700, color: "#1f2430", marginBottom: 8 }}>
                                    Financial Access Required
                                </Typography>
                                <Typography variant="body1" style={{ color: "#6b7280", maxWidth: 440, margin: "0 auto" }}>
                                    You need the <strong>Pay Invoices &amp; Super</strong> permission on this venue profile to view the Super Ledger.
                                </Typography>
                            </div>
                        ) : null}
                        {!isStaffWithoutFinancial && currentProfile ? (
                                <Heading title="Super Ledgers">
                                <Grid container spacing={8} justify="flex-end" alignItems="center">
                                    {/* <Grid item>
                                        <Select
                                            multiple
                                            label="Filter"
                                            className="dark-select"
                                            value={ invoiceStatusFilter.slice() }
                                            onChange={this.handleStatusFilterChange}
                                            input={<Input id="select-multiple-checkbox" />}
                                            renderValue={selected => selected.join(', ')}
                                            fullWidth
                                            inputProps={{
                                                color: "primary"
                                            }}
                                            classes={{
                                                root: "text-white",
                                                icon: "text-white"
                                            }}
                                        >
                                            <MenuItem value="Pending">
                                                <Checkbox checked={invoiceStatusFilter.slice().indexOf("Pending") > -1} />
                                                <ListItemText primary = "Pending"/>
                                            </MenuItem>
                                            <MenuItem value="Outstanding">
                                                <Checkbox checked={invoiceStatusFilter.slice().indexOf("Outstanding") > -1} />
                                                <ListItemText primary = "Outstanding"/>
                                            </MenuItem>
                                            <MenuItem value="Paid">
                                                <Checkbox checked={invoiceStatusFilter.slice().indexOf("Paid") > -1} />
                                                <ListItemText primary = "Paid"/>
                                            </MenuItem>
                                            <MenuItem value="Overdue">
                                                <Checkbox checked={invoiceStatusFilter.slice().indexOf("Overdue") > -1} />
                                                <ListItemText primary = "Overdue"/>
                                            </MenuItem>
                                        </Select>
                                    </Grid> */}
                                    {
                                        currentProfile.type === ProfileType.Agent.ordinal || currentProfile.type === ProfileType.Staff.ordinal ? (
                                            <Grid item>
                                                 <SelectFieldVenueFilter
                                                    suggestions={this.mapContactSuggestions(currentProfile.type)}
                                                    onChange={this.handleSelectContactFilter}
                                                    value={ filter.contactName }
                                                    placeholder="All Contacts"
                                                    color='#A9A9A9'
                                                    classes={{
                                                        root: "pull-right dark-select slim-input",
                                                        icon: "text-white",
                                                        input: "text-primary"
                                                    }}
                                                />
                                                {/* <BookingCalendarFilter
                                                    id="invoiceContactFilter"
                                                    suggestions={}
                                                    onChange={this.handleSelectContactFilter}
                                                    value={ filter.contactName }
                                                    placeholder="All Contacts"
                                                    fullWidth={this.props.width === "xs" || this.props.width === "sm"}
                                                /> */}
                                            </Grid>
                                        ) : null
                                    }
                                    <Grid item>
                                        {currentProfile.type === ProfileType.Staff.ordinal ? (
                                            <StaffFilter postChangeEvent={this.reloadLedger} hideAllTime={true} />
                                        ) : (
                                            <ReportDateFilter isLoading={firstLoaded} postChangeEvent={this.reloadLedger} hideAllTime={true} />
                                        )}
                                    </Grid>
                                </Grid>
                            </Heading>
    
                        ): null}
                        {!isStaffWithoutFinancial && <Paper style={{ position: "relative" }}>
                            <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                {currentProfile && (currentProfile.type === ProfileType.Staff.ordinal || currentProfile.type === ProfileType.PrivateHire.ordinal) ?  <Tabs
                                    value={this.state.tabValue}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="secondary"
                                    scrollable
                                    scrollButtons="off"
                                    classes={{
                                        root: "tabs-root",
                                        indicator: "tabs-indicator"
                                    }}
                                >
                                    <Tab label={this.renderTabTitle("Super I Owe", [])} classes={{ selected: "tab-selected" }} />
                                </Tabs> :  <Tabs
                                    value={this.state.tabValue}
                                    onChange={this.handleTabChange}
                                    indicatorColor="primary"
                                    textColor="secondary"
                                    scrollable
                                    scrollButtons="off"
                                    classes={{
                                        root: "tabs-root",
                                        indicator: "tabs-indicator"
                                    }}
                                >
                                    <Tab label={this.renderTabTitle("Super Owed to Me", [])} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderTabTitle("Super I Owe", [])} classes={{ selected: "tab-selected" }} />
                                </Tabs>}
                                
                            </AppBar>
                            <Paper className="org-paper-form" style={{ borderRadius: "0px 0px 2px 2px", position: "relative" }}>
                                <Loading showed={isLoading} />
                                
                                {currentProfile && (currentProfile.type === ProfileType.Staff.ordinal || currentProfile.type === ProfileType.PrivateHire.ordinal) ? this.renderTabStaffComponent() : this.renderTabComponent() }
                                
                                {/* {this.props.profileStore.currentProfile.type === ProfileType.Staff.ordinal ? <IncomingLedgers /> : this.renderTabComponent()} */}
                                
                            </Paper>
                        </Paper>}
                        <SuperLedgerReportModal
                            open={this.state.reportModalOpen}
                            onClose={this.handleCloseReportModal}
                            ledgers={this.state.selectedReportLedgers}
                            ledgerType={this.state.reportLedgerType}
                        />
                    </Fragment>
                </MainContainer>
            </div>
        );
    }
}

export default SuperLedgers;
